import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CreateTypeNoteDTO, TypeNote, UpdateTypeNoteDTO } from '../models/type-note.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IResponse } from '../models/response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TypeNotesService {

  url = `${environment.url}/api`;

  constructor(
    private http: HttpClient
  ) { }

  typeNotesBs: BehaviorSubject<TypeNote[]> = new BehaviorSubject<TypeNote[]>([]);

  getAll(): Observable<IResponse<TypeNote[]>> {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
    return this.http.get<IResponse<TypeNote[]>>(`${this.url}/tipoNotaMantenimiento`, { headers });
  }

  create(createTypeNoteDTO: CreateTypeNoteDTO): Observable<IResponse<TypeNote>> {
    return this.http.post<IResponse<TypeNote>>(`${this.url}/tipoNotaMantenimiento`, createTypeNoteDTO);
  }

  update(updateTypeNoteDTO: UpdateTypeNoteDTO): Observable<IResponse<TypeNote>> {
    return this.http.put<IResponse<TypeNote>>(`${this.url}/tipoNotaMantenimiento/${updateTypeNoteDTO.id}`, updateTypeNoteDTO);
  }

  delete(id: number): Observable<IResponse<TypeNote>> {
    return this.http.delete<IResponse<TypeNote>>(`${this.url}/tipoNotaMantenimiento/${id}`);
  }

  getTypeNotes(): TypeNote[] {
    return this.typeNotesBs.getValue();
  }

  updateTypeNotes(typeNotes: TypeNote[]) {
    this.typeNotesBs.next(typeNotes);
  }
}
